import { render, staticRenderFns } from "./exitIcon.vue?vue&type=template&id=43092bcc&"
import script from "./exitIcon.vue?vue&type=script&lang=js&"
export * from "./exitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports